export const MONITORING_OVERVIEW = /* GraphQL */ `
  query MonitoringOverview {
    monitoringOverview {
      totalTrackedKeywords
      totalTrackedChannels
      avgScore
      alertCount
    }
  }
`;

export const RANK_CHANGES = /* GraphQL */ `
  query RankChanges($limit: Int) {
    rankChanges(limit: $limit) {
      keyword
      contentUrl
      previousRank
      currentRank
      change
      detectedAt
    }
  }
`;

export const SCORE_CHANGES = /* GraphQL */ `
  query ScoreChanges($limit: Int) {
    scoreChanges(limit: $limit) {
      contentUrl
      previousScore
      currentScore
      change
      detectedAt
    }
  }
`;
